import React, { Component } from "react";
import { Pie, measureTextWidth } from "@ant-design/charts";

export default class PieChart extends Component {
  renderStatistic(containerWidth, text, style) {
    const { width: textWidth, height: textHeight } = measureTextWidth(
      text,
      style
    );
    const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

    let scale = 1;

    if (containerWidth < textWidth) {
      scale = Math.min(
        Math.sqrt(
          Math.abs(
            Math.pow(R, 2) /
              (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2))
          )
        ),
        1
      );
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${scale}em;line-height:${
      scale < 1 ? 1 : "inherit"
    };">${text}</div>`;
  }

  data = [
    {
      type: "0 images",
      value: this.props.data.filter(function (article) {
        return article.n_images == 0;
      }).length,
    },
    {
      type: "1 image",
      value: this.props.data.filter(function (article) {
        return article.n_images == 1;
      }).length,
    },
    {
      type: "+2 images",
      value: this.props.data.filter(function (article) {
        return article.n_images > 1;
      }).length,
    },
  ];
  config = {
    appendPadding: 10,
    data: this.data,
    angleField: "value",
    colorField: "type",
    color: ["#FF7875", "#91D5FF", "#40A9FF"],
    radius: 1,
    innerRadius: 0.64,
    label: {
      type: "inner",
      offset: "-50%",
      style: {
        textAlign: "center",
      },
      autoRotate: false,
      content: "{value}",
    },
    legend: {
      position: "top",
    },
    statistic: {
      title: {
        offsetY: -14,
        customHtml: (container, view, datum) => {
          const { width, height } = container.getBoundingClientRect();
          const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
          const text = datum ? datum.type : "Total";
          return this.renderStatistic(d, text, {
            fontSize: 28,
          });
        },
      },
      content: {
        offsetY: -10,
        style: {
          fontSize: "32px",
        },
        customHtml: (container, view, datum, data) => {
          const { width } = container.getBoundingClientRect();
          const text = datum
            ? `${datum.value}`
            : `${data.reduce((r, d) => r + d.value, 0)}`;
          return this.renderStatistic(width, text, {
            fontSize: 32,
          });
        },
      },
    },

    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
      {
        type: "pie-statistic-active",
      },
    ],
  };

  render() {
    return <Pie {...this.config} />;
  }
}
